var Base = require('_js/base'),
  ko = require('knockout'),
  $ = require('jquery');

var model = function(params) {
  this.params = params;
};

function AdminToolUserManagement() {
  this.init();
}

AdminToolUserManagement.prototype = new Base();

AdminToolUserManagement.prototype.init = function() {
  var $admin = $('[data-admin-tool-user-management]');
  if ($admin.get(0) !== undefined) {
    ko.applyBindings(
      new model({ element: $admin.data('admin') }),
      $admin.get(0)
    );
  }
};

module.exports = AdminToolUserManagement;
